import './styles.css';

/** Landing page motion hooks — keep light; CSS handles primary animation. */
document.documentElement.classList.add('js');
